
const ReviewData = [
    {
        id: 1,
        name: 'REM dcs',
        desc: "Looking for a nail spa open at 10pm. So fortunate to have found M Nail & Lash Nail Salon. They welcomed me in, treated me like we’ve been friends forever. Needed a mani/pedi and told them my feet hurt. They gave me a a hot stone massage with my pedicure with a very flavorful adult beverage and I was good as new. Best part…THEY’RE RIGHT NEXT TO CENTRAL MARKET at Coit and George Bush Hwy. Where have you been all my life!!! Thank you so much. Very friendly people.",
        star: 5
    },
    {
        id: 2,
        name: 'Hanh Tran',
        desc: "I’m truly impressed with the service here! I got a pedicure and a full set of acrylics – both were absolutely amazing. The foot massage was professional and relaxing, hitting all the right spots and making me feel completely at ease. My acrylic nails turned out stunning, with every detail done perfectly just the way I wanted.",
        star: 5
    },
    {
        id: 3,
        name: 'Minh Kinney',
        desc: "I absolutely love going here…. The amazing customer service and hospitality they were receive here is unmatched ……",
        star: 5
    },
    {
        id: 4,
        name: 'Chelita McDuffie',
        desc: "Love going here. My nails always turn out awesome. They really take their time!",
        star: 5
    },
    {
        id: 5,
        name: 'Ida Conte',
        desc: "Omg, Kae and Missile were absolutely wonderful! I came in during the late hours, and they were still so happy, positive, and welcoming. There was no rush at all—they took their time and made sure everything was perfect. I got my nails and feet done, and they look amazing. My experience was so relaxing and enjoyable. I would love to come back to them again. Highly recommend!",
        star: 5
    },
    {
        id: 6,
        name: 'Laura Mendez',
        desc: "Thank you for your service, had a nice massage along with a mimosa. This was extremely relaxing and my nails came out beautiful 🫶🏻",
        star: 4
    },
    {
        id: 7,
        name: 'Sarah F',
        desc: "I'm from out of the area but every time I am in town I schedule a visit for a mani and pedi. I just love this place!! The service is always top notch, they are professional, efficient and I am always amazed with the results. I have had great experiences with the entire staff but Vy is my favorite. Highly recommended!",
        star: 5
    },
    {
        id: 8,
        name: 'Joy G',
        desc: "I have been coming to M Spa for 6 years now, Vivian goes above and beyond with quality service. She is very kind and hospitable, and very talented within her field. I have had my nails done by a few different techs at M Spa and they always do a good job. They give great attention to detail, they are very clean, and even the music in the salon is wonderful! I always enjoy my time here.",
        star: 5
    },
];

export default ReviewData;